var globalFav = 0;
if ($('#my-favorites').length) {
    var favOrderInncr = 5;
    var isFavoriteStoreModal = false;
    var currentStore = orderViewModel.store && orderViewModel.store.id || 0;
    // if storeId not found in cached client storage, try to retrieve from hidden field
    if (currentStore != 0) {
        var currentUrl = $('#backLinkUrl').attr('href');
        if (currentUrl && currentUrl.indexOf(currentStore) === -1) {
            var updatedUrl = currentUrl + '/restaurant/' + currentStore + '/menu';
            $("#backLinkUrl").attr("href", updatedUrl);
        }
    }
    function addToBag(storeId, cartId, itemId, productId, itemPrice, isCombo = false) {
        var submitRoute = $('#frmReorderItemToCart').attr('action');
        if (cartId == null) {
            favCreateCart(storeId);
            cartId = orderViewModel.currentOrder.cartId;
        }
        const analyticsOrderSourceType = analytics.orderSourceType.favoriteOrderCart ? analytics.orderSourceType.favoriteOrderCart.toLowerCase() : "";
        var model = {
            StoreId: storeId,
            CurrentOrderCartId: cartId,
            ReorderedItemCartItemId: itemId,




            OrderSourceType: analyticsOrderSourceType,
            ComboOriginSource: isCombo ? analyticsOrderSourceType : "n/a",

            "SiteName": $('#hdnSiteName') && $('#hdnSiteName').val() || ""
        };
        subwayScript.showSpinner();

        $.ajax({
            url: submitRoute,
            type: 'POST',
            data: model,
            success: function (response) {
                removeDancingBubbleIfAny();
                orderViewModel.currentOrder.cartId = response.CartId;
                orderViewModel.currentOrder.cartQuantity = response.CartItemQuantity;
                orderViewModel.addCartProducts(response.CartItemId, response.ProductID, response.CategoryId, '');
                orderViewModel.save();
                var addtoBagSource = false;
                if (isCurrentPage('home')) {
                    addtoBagSource = analytics.addToBagSources.favoritesHome;
                }
                else if (isCurrentPage('menu')) {
                    addtoBagSource = analytics.addToBagSources.menuFavoritesPage;
                }
                else {
                    addtoBagSource = analytics.addToBagSources.favoriteSubPage;
                }
                orderViewModel.OrderSourceType = analytics.orderSourceType.favoriteOrderCart ? analytics.orderSourceType.favoriteOrderCart.toLowerCase() : "";
                analytics.OrderSourceType(orderViewModel.OrderSourceType);
                const categoryName = response.CartCurrentItem.analytics && response.CartCurrentItem.analytics.categoryName ?
                    response.CartCurrentItem.analytics.categoryName :
                    response.CategoryName;
                orderViewModel.addAnalyticsCartProducts(response.CategoryId, response.ProductID, categoryName, response.AnalyticsName);
                orderViewModel.save();
                var toastedData = false;
                if (response.CartCurrentItem.options && response.CartCurrentItem.options.length > 1) {
                    toastedData = response.CartCurrentItem.options[1].optionName == 'Toasted' ? true : false;
                }
                const prdNameWithSize = response.CartCurrentItem && response.CartCurrentItem.productName
                const prdNameWithoutsize = response.CartCurrentItem && response.CartCurrentItem.analytics && response.CartCurrentItem.analytics.productName || ''
                const favProductId = response.CartCurrentItem && response.CartCurrentItem.productId;
                isMiamFvrt = response.CartCurrentItem.combo ? true : false;
                analytics.favCarousel(categoryName, prdNameWithoutsize, favProductId, response.CartCurrentItem.lineItemPrice, 1, addtoBagSource, response.CartQuantity, orderViewModel.currentOrder.favPosition, prdNameWithSize, response.CartCurrentItem.options, toastedData, isMiamFvrt, response.CartCurrentItem.combo);

                subwayScript.hideSpinner();
                $("#reOrderModal").hide();
                if (orderViewModel.currentOrder.cartQuantity > 0) {
                    localStorage.setItem("cartProgressBar", response.CartQuantity);
                    loadCartBag();
                }
                analytics.removalBannerAnalytics(AddToBagSuccessMsg);
            },
            error: function (jqXhr) {
                removeDancingBubbleIfAny();
                subwayScript.hideSpinner();
                modalClose(true);

                var errModel = subwayScript.showAjaxError(jqXhr, true);

                analytics.recordFavoritesError(errModel.title, errModel.body);
            }
        });
    }

    function ValidateItem(storeId, cartId, itemId, productId, itemPrice, favItem) {
        var submitRoute = $('#frmReorderItem').attr('action');
        var model = {
            StoreId: storeId,
            CurrentOrderCartId: cartId,
            ReorderedItemCartItemId: itemId
        };
        subwayScript.showSpinner();
        $.ajax({
            url: submitRoute,
            type: 'POST',
            data: model,
            success: function (response) {
                var isAvailable = response.Favorites[0].IsAvailable;
                var productName = response.Favorites[0].ProductName;
                var favoriteName = response.Favorites[0].FavoriteName;
                var itemDescription = response.Favorites[0].ItemDescription;
                var ingredientsAvailable = response.Favorites[0].AreAllIngredientsAvailable;
                var inStockItems = response.Favorites[0].InStockItems;
                var outofStockItems = response.Favorites[0].OutofStockItems;

                // if item is not available, add-to-bag CTA prompts user to Change Location
                if (isAvailable == "False" || !isAvailable) {
                    // open the itemUnavailable modal
                    $("#unavailable-product-name").text(productName);
                    $("#unavailable-fav-name").text(favoriteName);
                    $("#unavailable-item-description").html(itemDescription);
                    var itemUnavailable = $("#modal-fav-item-unavailable").find(".warning-text").text();
                    analytics.Unavailabilty(itemUnavailable);
                    modalShowId('#modal-fav-item-unavailable');


                    $('#fav-item-unavailable-back-to-menu').click(function () {
                        window.location.href = subwayScript.navigation.getMenuUrl(storeId);
                    });
                }
                // if any ingredients are not available, add-to-bag CTA prompts user to either add to bag AS IS or change Location
                else if (ingredientsAvailable == "False" || !ingredientsAvailable) {
                    // open the ingredientsUnavailable modal, setting the necessary parameters to addToCart in the modal's CTA
                    $("#ingredients-unavailable-product-name").text(productName);
                    $("#ingredients-unavailable-fav-name").text(favoriteName);
                    $("#instock-ingredients-unavailable-item-description").html(inStockItems);
                    $("#outofstock-ingredients-unavailable-item-description").html(outofStockItems);
                    var ingredientsUnavailable = $("#modal-fav-ingredients-unavailable").find(".Product-unavailable").text();
                    analytics.Unavailabilty(ingredientsUnavailable);
                    modalShowId('#modal-fav-ingredients-unavailable');
                    $('#fav-ingredients-unavailable-modal-add').click(function () {
                        addToBag(storeId, cartId, itemId, productId, itemPrice);
                        analytics.favoriteId(favoriteId);
                    });

                }
                else {
                    if (isAvailable && ingredientsAvailable && (favItem.closest('.accordionTitle').find('.accordion-title').attr('aria-expanded') != "true")) {
                        $("#available-product-name").text(productName);
                        $("#available-fav-name").text(favoriteName);
                        $("#available-item-description").html(itemDescription);
                        modalShowId('#modal-fav-item-available');

                        $('#fav-item-available-modal-add').click(function () {
                            addToBag(storeId, cartId, itemId, productId, itemPrice);
                            analytics.favoriteId(favoriteId);
                        });
                    }
                    else {
                        addToBag(storeId, cartId, itemId, productId, itemPrice);
                        analytics.favoriteId(favoriteId);
                    }
                }

            },
            error: function (jqXhr) {
                subwayScript.hideSpinner();
                modalClose(true);

                var errModel = subwayScript.showAjaxError(jqXhr, true);


                analytics.recordFavoritesError(errModel.title, errModel.body);
            }
        });
    }

    function ellipsizeTextBox(el) {
        var wordArray = el.innerHTML.split(' ');
        while (el.scrollHeight > el.offsetHeight) {
            wordArray.pop();
            el.innerHTML = wordArray.join(' ') + '...';
        }
    }

    function locatorRedirect(locatorURL) {
        var id = window.orderViewModel.store.id;
        if (id != null) {
            locatorURL = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
        }
        window.location.href = locatorURL;
    }

    function openLocatorModal() {
        modalShowId('#locator-modal-favorites');
        $('#subwayLocator').empty();
        compStoreLocator.Init(true);
    }

    function favoriteStoreAction() {
        if (orderViewModel.favStore.id != null && orderViewModel.favStore.id != '') {
            changeFavoriteLocationLink();
        }
        else {
            modalShowId('#locator-modal-favorites');
            $('#subwayLocator').empty();
            compStoreLocator.Init(true);
        }
    }

    function favCreateCart(storeID) {
        let createCartData = {
            StoreId: storeID !== null ? storeID : subwayScript.getStoreId(data.LocationId.StoreNumber, data.LocationId.SatelliteNumber),
            OrderType: orderViewModel.orderType
        };
        let result = false;
        subwayScript.showSpinner();
        $.ajax({
            url: '/RemoteOrder/Restaurant/CreateNewCart',
            type: 'POST',
            cache: false,
            async: false,
            headers: { "cache-control": "no-cache" },
            data: createCartData,
            error: function (jqXhr) {
                subwayScript.hideSpinner();
                subwayScript.showAjaxError(jqXhr);
            },
            success: function (resultData) {
                subwayScript.hideSpinner();
                if (resultData.Error) {
                    subwayScript.showAjaxError(resultData);
                } else if (!resultData.IsWebOrderAvailable) {
                    modalShowId('#modal-web-order-not-available');
                } else if (!resultData.IsStoreOpen) {
                    // IsStoreOpen is false, may be stores where local POS is offline or is unsupportive of checkout.
                    modalShowId('#modal-store-closed');
                } else {
                    $('#scLanguageCode').val(resultData.AvailableStoreCultures);
                    orderViewModel.flushCart();
                    orderViewModel.currentOrder.cartId = resultData.Cart.CartId;
                }
            }
        });
        return result;
    }


    function LoadMyFavorite() {
        var DefaultStoreIDValue = $('#StoreIDDefaultValue').val();
        var $form = $('#frmMyFavorites');
        var isDefaultStoreId = false;
        var $frmCreateCart = $('#frmCreateCart');

        /// Favorites list is based on Ordering From Store ID then Profile Preferences Favorite Store ID
        var storeId = $('#storeId', $frmCreateCart).val() ? $('#storeId', $frmCreateCart).val() : (orderViewModel.store && orderViewModel.store.id) || 0;

        if (storeId === 0) {
            isDefaultStoreId = true;
            storeId = DefaultStoreIDValue;

        }
        var action = $form.attr('action');
        $('#StoreId', $form).val(storeId);
        $('#IsDefaultStoreId', $form).val(isDefaultStoreId);

        ajaxGetResults(action, 'frmMyFavorites');
    }

    function ajaxGetResults(postUrl, formId) {
        $('#favoriteSkeletonHeading').show();
        $('#favoriteSkeletonDesc').show();
        $('#dash-favorite-panel').prev().hide();
        $('#BestSeller').hide();
        $('#favoriteAnalytics').removeClass("Analytics-Title");
        $.ajax({
            url: postUrl,
            type: 'POST',
            data: $('#' + formId).serialize(),
            success: function (data) {
                $('#favoriteSkeletonHeading').hide();
                $('#favoriteSkeletonDesc').hide();
                $('.dash-my-favorites .gridTitle-menu').show();
                $('#dash-favorite-panel #skeletonLoader').removeClass("skeleton--favorite_skeletonLoader");
                document.dispatchEvent(new CustomEvent('apiCallSuccess'));
                if (data) {
                    $('#favoriteAnalytics').addClass("Analytics-Title");
                }
                $('#dash-favorite-panel').prev().show();

                if ($("#isDashboard").val() == "True") {
                    $('#dash-favorite-panel').html(data);
                    dashPageActions(data);
                }
                else {
                    $('.my-fav-subpage').show();
                    $('#favlist').html(data);

                    favpageActions();

                    $('.favorites-content .accordionTitle:even').each(function () {
                        $(this).prop('style', 'background-color:#ffffff !important');
                    });

                    $('.favorites-content .accordionTitle:odd').each(function () {
                        $(this).prop('style', 'background-color:#f0f0f0 !important');
                    });

                    $('.favorites-content .layer:first .accordionTitle .accordion-title').addClass('is-expanded');
                    $('.favorites-content .layer:first .accordionTitle .accordion-title').attr('aria-expanded', true);
                    $('.favorites-content .layer:first .accordion-content').removeClass('is-collapsed');
                    $('.favorites-content .layer:first .accordion-content').addClass('is-expanded');
                    $('.favorites-content .layer:first .accordion-content').attr('aria-hidden', 'false');
                    $('.favorites-content .layer:first .accordionTitle .accordion-title').children('.icon-expand_more').addClass('is-expanded').removeClass('is-collapsed');

                    if ($('[data-component="my-favorites-grid"]').length) {
                        createNewCart();
                    }
                    showMoreFavorites();
                    $('.accordion-title').on('click keypress', function (e) {
                        if (e.which === keyCodes.RETURN || e.type === 'click') {
                            if ($(this).closest('.accordionTitle').next('.accordion-content').hasClass('is-collapsed')) {

                                $(this).addClass('is-expanded').removeClass('is-collapsed');
                                $(this).children('.icon-expand_more').addClass('is-expanded').removeClass('is-collapsed');
                                $(this).closest('.accordionTitle').next('.accordion-content').addClass('is-expanded').removeClass('is-collapsed');
                                $(this).parent().find('.outside-controls').addClass('hide-remove');
                                $(this).attr('aria-expanded', true);
                                $(this).closest('.accordionTitle').next('.accordion-content').attr('aria-hidden', false);
                            }
                            else {
                                $(this).parent().find('.outside-controls').removeClass('hide-remove');
                                $(this).children('.icon-expand_more').addClass('is-collapsed').removeClass('is-expanded');
                                $(this).addClass('is-collapsed').removeClass('is-expanded');
                                $(this).closest('.accordionTitle').next('.accordion-content').addClass('is-collapsed').removeClass('is-expanded');
                                $(this).attr('aria-expanded', false);
                                $(this).closest('.accordionTitle').next('.accordion-content').attr('aria-hidden', true);
                            }
                        }
                    });
                }

                orderViewModel.favoriteItemCount = $("#num-favorites").val();
                orderViewModel.save();
                $('.product-grid #title').each(function () { ellipsizeTextBox(this) });

                if ($("#num-favorites").val() > 1) {
                    $('.view-all-favorite').attr('style', '');
                } else {
                    $('.view-all-favorite').css('display', 'none');
                }


                if ($('#num-favorites').val() == 0 || $('#num-favorites').val() == undefined) {
                    $('#dash-favorite-panel').prev().hide();
                    $('#Favorites').hide();
                    ajaxBestSeller();
                }
                else {
                    analytics.DBFavoritesOrBestsellers('favorites');
                    $('#BestSeller').hide();
                    SlickRender();
                }
                if (isCurrentPage('my-favorites')) {
                    $('.favorites-loader').hide();
                    subwayScript.hideSpinner1();
                }
                $(".fav-card-resp-height").attr("tabindex", "0");
                $('#Favorites .favorites-carousel .slick-track .fav-card-resp-height').on('click keypress', function (event) {
                    if (event.which === keyCodes.RETURN || event.type === "click") {
                    const uniqueId = 'dancing-bubble-' + Math.random().toString(36).substr(2, 9);
                    const dancingBubbleTarget = document.createElement('div');
                    dancingBubbleTarget.classList.add('dancing-bubble-target');
                    dancingBubbleTarget.id = uniqueId;
                    dancingBubbleTarget.style.width = '58px';
                    dancingBubbleTarget.style.position = 'absolute';
                    dancingBubbleTarget.style.top = '0px';
                    dancingBubbleTarget.style.right = '1rem';

                    const currentTarget = event.currentTarget;
                    currentTarget.style.position = 'relative';
                    currentTarget.appendChild(dancingBubbleTarget);

                    currentTarget.classList.add('half-opacity');

                    const dancingBubbleEvent = { target: dancingBubbleTarget };
                    applyDancingBubble(dancingBubbleEvent, 'green', true);

                    onClickFavoriteReOrder(event);
                    }
                });
            },
            error: function (jqXhr) {
                $('#dash-favorite-panel #skeletonLoader').removeClass("skeleton--favorite_skeletonLoader");
                modalClose(true);

                if ($('.api-error').length) {
                    $('.store-container, .view-all-favorite').css('display', 'none');
                } else {
                    $('.store-container, .view-all-favorite').attr('style', '');
                }

                $('.favorites-loader').hide();
                subwayScript.hideSpinner1();
            }
        });
    }

    function favpageActions() {

        var $startOrder = $('#btnStartOrder');
        var startOrderUrl;

        if (orderViewModel.store && orderViewModel.store.id) {
            startOrderUrl = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
        }
        else {
            startOrderUrl = subwayScript.navigation.getLocatorUrl();
        }

        $startOrder.attr('href', startOrderUrl);

        //remove favorites store modal
        $('#deleteFavoriteStore').on('click keypress', function (e) {
            if (e.which === keyCodes.RETURN || e.type === 'click') {
                var lastFocus = document.activeElement;
                isFavoriteStoreModal = true;
                modalShowId('#modal-remove-item');
                subwayScript.bindModalToLastFocus(e, lastFocus, 'modal-remove-favorite-store');
            }
        });

        $('#btnRemoveFav').on('click keypress', function () {
            subwayScript.showSpinner();
            if (!isFavoriteStoreModal) {
                removeFavoriteItem(removeItemRoute, $removedElement);
            }
            else {
                updateFavStore();
            }
        });

        $('.fav-location').css({
            'cursor': 'pointer',
            'pointer-events': 'auto'
        });
        if (orderViewModel.favStore.id != null && orderViewModel.favStore.id != '') {
            $('.my-fav-top').show();
            $('.change-text').show();
            var address3 = orderViewModel.favStore.address3 ? ', ' + orderViewModel.favStore.address3 : '';
            $('.dash-fav-location, .my-fav-location').html(orderViewModel.favStore.address1 + address3);
            $('.change-favorite-location, .change-text').show();
        }
        if (orderViewModel.favStore.id == null || orderViewModel.favStore.id == '') {
            $('.my-fav-top').show();
            $('.change-text').hide();
            $('.dash-fav-location, .my-fav-location').html($(".my-fav-subpage").attr("data-select-fav"));
            $('.change-favorite-location, .change-text').hide();
        }

        var numFavorites = $('#num-favorites').val();
        if (numFavorites > 0) {
            $('.favorites-content').show();
            $('.no-favorites').hide();

            var $removedElement;
            var removeItemRoute = $('#frmRemoveFavItem').attr('action');

            var $editToggle = $('#toggleEdit');
            var editText = $editToggle.data('edit');
            var doneText = $editToggle.data('done');
            var editTitleText = $editToggle.data('edit-title');

            $editToggle.on('click', function () {
                if ($editToggle.text().trim() === editText.trim()) {
                    $('.toggle-text').text(doneText);
                    $('.toggle-text').attr('title', doneText);
                    $('#toggleEdit i').removeClass('fa-pencil-alt').addClass('fa-check');
                    $('.favorites-page .icon-add-to-bag, .favorites-page .reorder-button').addClass('hide-remove').removeClass('show-remove');
                    $('.favorites-page .icon-delete').removeClass('hide-remove').addClass('show-remove');

                }
                else {
                    $('.toggle-text').text(editText);
                    $('.toggle-text').attr('title', editTitleText);
                    $('#toggleEdit i').removeClass('fa-check').addClass('fa-pencil-alt');
                    $('.favorites-page .icon-add-to-bag, .favorites-page .reorder-button').removeClass('hide-remove').addClass('show-remove');
                    $('.favorites-page .icon-delete').addClass('hide-remove').removeClass('show-remove');

                }
            });

            //ADA added in functionality for the enter key to trigger the remove favorite modal
            $('.id-open.icon-delete').on('click keypress', function (e) {
                e.stopPropagation()
                if (e.which === keyCodes.RETURN || e.type === 'click') {
                    var $parent = $(this).parents('.layer').first();
                    var lastFocus = document.activeElement;
                    $removedElement = $parent;
                    var itemName = $parent.data('name');
                    removeItemCartId = $parent.data('cartid');

                    $('#remove-item-name').html(itemName);
                    isFavoriteStoreModal = false;
                    modalShowId('#modal-remove-item');
                    globalUtil.modalPopupOpen('#modal-remove-item');

                    subwayScript.bindModalToLastFocus(e, lastFocus, 'modal-remove-item');
                }
            });


            $('.icon-add-to-bag, .reorder-button').click(function () {
                if (subwayScript.isMaxProteinReached()) {
                    return;
                }
                if (!orderViewModel.store || !orderViewModel.store.id) {
                    subwayScript.showLocationRequiredModal();
                    return;
                }
                subwayScript.showSpinner();
                var $parent = $(this).parents('.layer');
                var favItem = $(this);

                var selectedFavorite = {
                    CartItemId: $parent.data('cartid'),
                    ProductId: $parent.data('productId'),
                    Price: parseFloat($parent.data('price')).toFixed(2),
                    IsAvailable: $(this).data('available'),
                    AreAllIngredientsAvailable: $(this).data('ingredients-available'),
                    ProductName: $(this).data('product-name'),
                    FavoriteName: $(this).data('favorite-name'),
                    ItemDescription: $(this).data('item-description'),
                    ProductClassGroupId: $parent.data('product-classgroupid'),
                    InStockItems: $(this).data('instock-item-description'),
                    OutofStockItems: $(this).data('outofstock-item-description')

                }
                showFavoritesModal(selectedFavorite, favItem);
                subwayScript.hideSpinner();
            });
        }
        else {
            $('#toggleEdit').hide();
            $('.favorites-content').hide();
            $('.no-favorites').show();
        }

        $('.reorder-link').click(function () {


            var $parent = $(this).parents('li');
            var itemId = $parent.data('cartid');
            var productId = $parent.data('productId');
            var itemPrice = $parent.data('price');
            var storeId = $('#StoreId').val();
            var cartId = orderViewModel.currentOrder.cartId;
            var itemUrl = $parent.data('itemurl');

            var isAvailable = $(this).data('available');
            var ingredientsAvailable = $(this).data('ingredients-available');

            // if item is not available, add-to-bag CTA prompts user to Change Location
            if (isAvailable == "False") {
                return;
            }
            else {
                window.location.href = itemUrl;

            }

        });

        var resizeTimer
        $(window).resize(function (e) {

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                $('.product-grid #title').each(function () { ellipsizeTextBox(this) });
            }, 5);

        });
    }

    function showFavoritesModal(selectedFavorite, favItem) {
        var cartId = orderViewModel.currentOrder.cartId;
        var storeId = orderViewModel.store.id;
        var itemId = selectedFavorite.CartItemId;
        var productId = selectedFavorite.ProductId;
        var itemPrice = selectedFavorite.Price;
        var favoriteId = selectedFavorite.CartItemId;
        analytics.favoriteCart(cartId, favoriteId);

        ValidateItem(storeId, cartId, itemId, productId, itemPrice, favItem);

    }
    function ViewFavorites(event) {
        event.stopPropagation();
        applyDancingBubble(event, 'gray')
        var favUrl = $('.favoriteViewAll').attr('data-favurl')
        analytics.closeModal();
        analytics.viewAllCta('view all');
        setTimeout(() => {
            window.location.href = window.location.origin + favUrl;
        }, 500)
    }
    function dashPageActions() {
        var numFavorites = $('#num-favorites').val();
        //homepage favorite dashboard
        var favoriteItems = orderViewModel.favoriteItems;
        $('.favorites-location').css({
            'cursor': 'pointer',
            'pointer-events': 'auto'
        });
        if (orderViewModel.favStore.id != null && orderViewModel.favStore.id != '') {
            $('.store-container').show();
            $('.change-favorite-location').show();
        }
        if (orderViewModel.favStore.id == null || orderViewModel.favStore.id == '') {
            $('.store-container').show();
            $('.change-favorite-location').hide();
        }

        if (numFavorites > 0) {
            // display favorite store as per below condition

            $('.dash-fav-details').off('click').on('click', function (e) {
                if (subwayScript.isMaxProteinReached()) {
                    return;
                }
                if (!orderViewModel.store || !orderViewModel.store.id) {
                    subwayScript.showLocationRequiredModal();
                    return;
                }
                var favItem = $(this);
                var cartItemID = $(this).parents('.favorite-data').attr('data-cart-id');
                var selectedFavorite = favoriteItems.filter(function (fav) {
                    return fav.CartItemId === cartItemID;
                });
                showFavoritesModal(selectedFavorite[0], favItem);
            });
        }
    }
    function showMoreFavorites() {
        var $favOrders = $('#favorites-page .layer');
        var favOrdersShown = $favOrders.filter(':visible').length;
        var data = $('.layer').length;
        var i;
        var j = favOrdersShown;

        for (i = globalFav; i < Math.min($favOrders.length, globalFav + favOrderInncr); i++) {
            $($favOrders[i]).show();
        }
        globalFav = globalFav + favOrderInncr;

        if ((favOrdersShown + favOrderInncr) < data) {
            $('#favorites-page .show-more').show();
        } else $('#favorites-page .show-more').hide();
        if (j != 0 || j >= favOrderInncr) {
            var accordian = $('.accordion-title', '#favorites-page');
            $(accordian)[j].focus();
        }
    }

    var removeFavoriteItem = function (removeItemRoute, $removedElement) {
        var removeItemCartId = $removedElement.data('cartid');
        $.ajax({
            url: removeItemRoute,
            type: 'POST',
            data: { cartItemId: removeItemCartId },
            success: function (response) {
                $removedElement.addClass('removed');
                $removedElement.find('i[aria-hidden=true]').css('visibility', 'hidden');
                $removedElement.find('span[aria-hidden=true]').css('visibility', 'hidden');
                $('.layer')
                    .one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                        function (e) {
                            $($removedElement).addClass('hide-remove');
                        });
                subwayScript.hideSpinner();
                modalClose(true);
                $("html, body").animate({ scrollTop: 0 }, "slow");
                $('#showHideMsg').show();
                setTimeout(function () {
                    $('#showHideMsg').hide();
                }, 5000);


                if ($(".favorites-content .layer").not('.removed').length === 0) {
                    $('#toggleEdit').hide();
                    $('.favorites-content').hide();
                    $('.no-favorites').show();
                }
                document.querySelector('#modal-remove-item .btn-close').addEventListener('keydown', function (event) {
                    if (event.type === 'click' || event.which === 13) {
                        setTimeout(function () {
                            lastFocus.focus();
                        }, 500);
                    }
                });
                $(document).keyup(function (e) {
                    if (e.key === 'Escape' || e.key === 'Esc') { // escape key maps to keycode `27`
                        setTimeout(function () {
                            lastFocus.focus();
                        }, 500);
                    }
                });

            },
            error: function (jqXhr) {
                subwayScript.hideSpinner();
                modalClose(true);

                var errModel = subwayScript.showAjaxError(jqXhr, true);


                analytics.recordFavoritesError(errModel.title, errModel.body);
            }
        });
    };

    var updateFavStore = function (storeNumber, satelliteNumber) {
        var updateFavStorEndpoint = $('#frmUpdateFavStore').attr('action');
        $.ajax({
            url: updateFavStorEndpoint,
            type: 'POST',
            data: {
                storeId: ''
            },
            error: function (jqXhr) {
                subwayScript.hideSpinner();
                subwayScript.showAjaxError(jqXhr);
            },
            success: function (data) {
                orderViewModel.favStore.storeNumber = data.LocationId ? data.LocationId.StoreNumber : "";
                orderViewModel.favStore.satelliteNumber = data.LocationId ? data.LocationId.SatelliteNumber : "";
                orderViewModel.favStore.id = "";
                orderViewModel.favStore.storeNumber = "";
                orderViewModel.save();
                subwayScript.hideSpinner();
                $('.change-favorite-location, .change-text').show();
                modalClose(true);
                favpageActions();

            }
        });
    };

    var changeFavoriteLocationLink = function () {
        if (orderViewModel.store.id != null && orderViewModel.currentOrder.cartQuantity != 0) {
            if (orderViewModel.store.id != orderViewModel.favStore.id) {
                orderViewModel.changeFavoriteStore = true;
                orderViewModel.save();
                modalShowId('#change-store');
                return false;
            }
        }
        window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.favStore.id);
    };
}
function ajaxBestSeller(forGuestuser) {
    if ($('#bestseller-component').length) {
        $('#bestseller-component').show()
        var bestSellerUrl = $('#frmBestSellers').attr('action');
        var $frmCreateCart = $('#frmCreateCart');
        var model = {
            DefaultStoreId: $("#defaultStoreId").val(),
            SelectedStoreId: $('#storeId', $frmCreateCart).val() ? $('#storeId', $frmCreateCart).val() : (orderViewModel.store && orderViewModel.store.id) || 0,
            CategoryId: parseInt($("#bestSellerCategoryId").val()),
            CultureCode: $("#hdnSiteName") && $("#hdnSiteName").val() || "en-us"
        };
        $('#bestSellerAnalytics').removeClass("Analytics-Title");

        $('#BestSeller').show();
        $('#BestSeller .gridTitle').hide();
        launchdarkly.HideBestSellers();
        orderViewModel.categoryDisplayName = "";
        orderViewModel.save();


        $.ajax({
            url: bestSellerUrl,
            type: 'POST',
            data: model,
            error: function (jqXhr) {
                $('#BestSeller').hide();
                subwayScript.showAjaxError(jqXhr);
            },
            success: function (data) {
                if (data) {
                    analytics.DBFavoritesOrBestsellers('best sellers');
                    $('#bestSellerAnalytics').addClass("Analytics-Title");
                    $(".skeleton--bestseller_skeletonLoader").remove()
                    document.dispatchEvent(new CustomEvent('apiCallSuccess'));
                }
                $('#bestSellerItems').html(data);
                if ($('#bestSellerItems').text() && data) {
                    $('#bestSellerAnalytics').show();
                    if (forGuestuser && isCurrentPage('menu')) {
                        $('#BestSeller').removeClass('bestseller')
                        $('#BestSeller').addClass('container')
                    }
                    $("#bestseller-component").show()
                }
                else {
                    $('#bestSellerAnalytics').hide();
                    $("#bestseller-component").hide()
                }
                if ($('#BestSeller').length > 0) {
                    SlickRender();
                    $("#bestsellerCarousel .bestseller_link").attr("tabindex", "0");
                    $("#bestsellerCarousel .bestseller_link").attr('aria-hidden', 'false');
                    $("#bestsellerCarousel").attr("role", "region");
                    $("#Best-Seller, .slick-track, .bestseller_link").removeAttr("role");
                    $("#Best-Seller, .slick-track").attr("role", "group")
                    $('.favorites-loader').hide();
                    $('#BestSeller .gridTitle').show();
                }
            }
        })

    }
}
function SlickRender() {

    $('.favorites-carousel').slick({
        dots: true,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        accessibility: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    })

    //Hide dots for use in count
    $('.favorites-carousel .slick-dots').hide();

    //Prev
    $('#slickPrev').on('click', function () {
        $('.favorites-carousel').slick('slickPrev');
    })

    //Next
    $('#slickNext').on('click', function () {
        $('.favorites-carousel').slick('slickNext');
    })

    $('.favorites-carousel, #bestsellerCarousel').on('afterChange', function (event, slick, currentSlide) {
        currentSlide === slick.slideCount - (slick.options.slidesToShow) ?
            ($('.slickNext').addClass('slick-disabled'))
            : ($('.slickNext').removeClass('slick-disabled'))
        slick.currentSlide === 0 ?
            ($('#slickPrev').attr("aria-disabled", "true"), $('.slickPrev').addClass('slick-disabled'))
            : ($('#slickPrev').removeAttr("aria-disabled"), $('.slickPrev').removeClass('slick-disabled'))
        setTimeout(() => {
            $("#bestsellerCarousel .bestseller_link").attr("tabindex", "0");
            $("#bestsellerCarousel").attr("role", "region")
            $("#Best-Seller, .slick-track, .bestseller_link").removeAttr("role");
            $("#Best-Seller, .slick-track, .bestseller_link").attr("role", "group");
            $("#bestsellerCarousel .bestseller_link").attr('aria-hidden', 'false');
        }, 500);
    });

    if (isCurrentPage('menu')) {
        $('.dash-my-favorites').addClass('favorites-top');
        if (orderViewModel.orderType == "delivery") {
            if ($(window).width() > 1024) {
                $('.favorites-top').css("margin-top", "0");
            }
        }
    }

    if ((window.innerWidth < 768 && $('.favorites-carousel .cursor-pointer').length <= 2) || (window.innerWidth >= 768 && $('.favorites-carousel .cursor-pointer').length <= 4)) {
        $('#Favorites .content').addClass("invisible");
    }

    if ((window.innerWidth < 768 && $('#num-bestsellers').val() <= 2) || (window.innerWidth > 768 && $('#num-bestsellers').val() <= 4)) {
        $('#slickPrev, #slickNext').hide();
    }

}

function onClickMyFavoriteReOrder(event) {
    event.stopPropagation()
    if (disableFavReorder !== "false") {
    } else {
        var reOrderCartId = event.currentTarget.children[1].getAttribute('data-cartid');
        var prodName = event.currentTarget.children[1].children[0].alt;
        analytics.favAccountLinkCall(prodName);
        if (orderViewModel.store.id) {

            onClickReOrderFavorite(reOrderCartId);
        }
        else {
            analytics.modalCheckOut('error warning modal')
            modalShowId('#modal-store-closed');

        }
    }
}


$(document).ready(function () {
    // we call the function
    (function () {
        if ($('#isUserLoggedIn').val() == '') {
            ajaxBestSeller(true)
        }
        if ($('#my-favorites').length) {
            var accordionState = $("#my-favorites").data("accordion-state");
            if ($("#isDashboard").val() === "False" || typeof ($("#isDashboard")).val() === "undefined") {
                if (isCurrentPage('my-favorites')) {
                    subwayScript.showSpinner1()
                }
                LoadMyFavorite();
            }
            else {
                if (accordionState === true) {
                    LoadMyFavorite();
                }
            }

            var favoritesLodadingIcon = document.getElementById('favorites-loading');
            if (favoritesLodadingIcon != null && typeof (favoritesLodadingIcon) != undefined) {
                if ($("#isDashboard").val() === "False" || typeof ($("#isDashboard")).val() === "undefined") {
                    favoritesLodadingIcon.src = spinner150;
                }
            }
        }
    })();
});
